import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "@/components/admin/header/PageHeader";
import { ExecuteTagAssignmentButton } from "@/components/admin/tag/ExecuteTagAssignmentButton";
import { TagAssignmentHistoryTable } from "@/components/admin/tag/TagAssignmentHistoryTable";
import { useTagAssignmentRuns } from "@/hooks/useTagAssignmentRuns";
import { useTags } from "@/hooks/useTags";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { showError } from "@/utils/notification";

const ExecuteTagAssignmentPage = () => {
  const { t } = useTranslation("admin");
  const { sessionCurrentWorkspaceId } = useWorkspaces();

  const {
    runs,
    error: fetchRunsError,
    isLoading: isLoadingRuns,
    currentPage,
    totalPages,
    goToPage,
    offset,
  } = useTagAssignmentRuns();

  const { tags } = useTags(sessionCurrentWorkspaceId || "");

  useEffect(() => {
    if (fetchRunsError) showError(t("tagAssignment.history.fetchError", "実行履歴の取得に失敗しました。"));
  }, [fetchRunsError, t]);

  return (
    <>
      <PageHeader hasBack={false} title={t("tagAssignment.title")} />
      <h2 style={{ marginTop: 0 }}>{t("tagAssignment.history.title")}</h2>
      <TagAssignmentHistoryTable
        runs={runs}
        isLoading={isLoadingRuns}
        tags={tags}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={goToPage}
        offset={offset}
      />

      <h2>{t("tagAssignment.execution")}</h2>
      <ExecuteTagAssignmentButton />
    </>
  );
};

export default ExecuteTagAssignmentPage;
